// src/pages/DigitalEngineeringHub.js
import React from 'react';

const DigitalEngineeringHub = () => {
  return (
    <main className="container flow" style={{ minHeight: '100vh', paddingTop: '48px' }}>
      <h1>Digital Engineering Hub</h1>

      <p>
        On major infrastructure projects, especially across Australia and New Zealand, coordination is often the limiting factor—not capability. Tools don’t connect. Knowledge is fragmented. People duplicate work without realising.
      </p>

      <p>
        The Digital Engineering Hub was built to reduce this friction.
      </p>

      <p>
        It started as a Miro board—notes, blockers, workarounds. We simplified it into something usable: a modular platform that supported how teams actually worked. Not a polished portal, just a clear way to find what you need and contribute as you go.
      </p>

      <p>
        The structure was deliberately simple. Each module could be added, removed, or adapted. Teams only used what was relevant. That made it scalable, low-maintenance, and easy to align with shifting needs.
      </p>

      <h2>Focus Areas</h2>
      <ul className="flow">
        <li>
          <strong>People & Knowledge:</strong> Lightweight profiles with skills, project roles, and links to training and reference material.
        </li>
        <li>
          <strong>Projects & Processes:</strong> A shared space for active digital initiatives tied to key workflows. Easy to update, easy to reuse.
        </li>
        <li>
          <strong>Navigation & Access:</strong> Visual team maps, reviewed examples, and a chatbot to surface the right context quickly.
        </li>
      </ul>

      <h2>Outcomes</h2>
      <ul className="flow">
        <li>Reduced time spent searching for documents and tools.</li>
        <li>Improved visibility of who’s doing what, and where to go for help.</li>
        <li>Made digital efforts more consistent across teams and projects.</li>
        <li>Created a foundation that could evolve without needing a full rebuild.</li>
      </ul>

      <h2>What Worked</h2>
      <p>
        We didn’t try to solve everything. We just focused on removing common points of friction—finding the right person, accessing useful materials, and sharing work that’s already been done. Everything else followed from that.
      </p>
    </main>
  );
};

export default DigitalEngineeringHub;
